// กติกาช่วงวันเวลาประชุม: วันเวลาสิ้นสุดต้องไม่ก่อนวันเวลาเริ่ม
// วันที่รูปแบบ YYYY-MM-DD และเวลา HH:mm จึงเทียบเป็นข้อความได้ตรงๆ

// เวลาสิ้นสุดที่เร็วที่สุดที่เลือกได้: จำกัดเฉพาะเมื่อสิ้นสุดวันเดียวกับวันเริ่ม
export function endTimeMin(startDate, startTime, endDate) {
  return startDate && startTime && endDate === startDate ? startTime : undefined;
}

export function isEndDateBeforeStart(startDate, endDate) {
  return !!(startDate && endDate && endDate < startDate);
}

export function isEndTimeBeforeStart(startDate, startTime, endDate, endTime) {
  return !!(startTime && endTime && startDate && endDate === startDate && endTime < startTime);
}
